import { useModalStore } from 'hooks/stores/useModalStore'
import { UnsavedChangesConfirmModal } from './UnsavedChangesConfirmModal/UnsavedChangesConfirmModal'

export const useConfirmUnsavedChanges = () => {
  const { openModal, closeModal } = useModalStore()
  return () => {
    return new Promise<Boolean>((resolve) => {
      openModal(UnsavedChangesConfirmModal, {
        customModal: true,
        modalProps: {
          onCancel: () => {
            resolve(false)
            closeModal()
          },
          onConfirm: () => {
            resolve(true)
            closeModal()
          },
        },
      })
    })
  }
}
